import { render, staticRenderFns } from "./statisticsPage.vue?vue&type=template&id=0fbbee32&scoped=true"
import script from "./statisticsPage.vue?vue&type=script&lang=js"
export * from "./statisticsPage.vue?vue&type=script&lang=js"
import style0 from "./statisticsPage.vue?vue&type=style&index=0&id=0fbbee32&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbbee32",
  null
  
)

export default component.exports